// Is the billing surface offered to this user?
//
// ONE predicate, shared by the settings-section registry and by the user-menu
// item that opens it. Those two disagreeing is not hypothetical — the menu
// entry was originally omitted while the section existed, so the section was
// only reachable by typing `?settings=usage-credits` by hand.
//
// Both gates are required and they are independent:
//   * audience — exact `@meta.com` (or the local debug bypass);
//   * `billing_sandbox_enabled` — default OFF, so the feature is absent
//     everywhere until it is deliberately turned on.

import { useAuth } from '../../contexts/AuthContext'
import { useBooleanFlagValue } from '../../hooks/useBooleanFlagValue'
import { canSeeBilling } from './billingAccess'

export function useBillingVisible(): boolean {
  const { user } = useAuth()
  const billingSandboxEnabled = useBooleanFlagValue('billing_sandbox_enabled', false)
  return canSeeBilling(user) && billingSandboxEnabled
}
